import { mapWFSAPI } from "../mapWFSApi"

export const mapWFSApiSlice = mapWFSAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение группировок для типа объектов
        getFeatureWFS: builder.query<any, any>({
            query: (args) => ({
                url: `?request=GetFeature&format_options=callback%3AloadFeatures&outputFormat=application%2Fjson&typeName=${args.workspace}%3A${args.layer}&version=2.0.0&CQL_FILTER=${args.cqlFilter}`
            })
        })
    })
})

export const {
    useLazyGetFeatureWFSQuery
} = mapWFSApiSlice
